export const sources={};export const img={src:"__VITE_ASSET__B8$br03g__",w:36,h:36};export default{sources:sources,img:img};